import { Component, Inject, OnInit } from '@angular/core';
import { FormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscriptionStatusEnum } from '@app/core/services/subscription/models/enum/subscription-status.enum';
import { MY_FORMATS } from '@app/core/services/util/util.service';
import { CustomDateAdapter } from '@app/shared/adapter/custom-date-adapter';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';

@Component({
    selector: 'ap-add-subscription-history-popup',
    templateUrl: './add-subscription-history-popup.component.html',
    styleUrl: './add-subscription-history-popup.component.css',
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useValue: MY_FORMATS
        },
        {
            provide: DateAdapter, useClass: CustomDateAdapter
        }
    ],
    standalone: false
})
export class AddSubscriptionHistoryPopupComponent implements OnInit {

  subscriptionChangeStatusFormGroup: UntypedFormGroup;
  targetStatusList: SubscriptionStatusEnum[] = [];
  minDate = moment(new Date()).add(1, 'd').toDate().toISOString().split("T")[0];
  maxReasons = 5;

  get isDeferred() { return this.subscriptionChangeStatusFormGroup.get('isDeferred'); }
  get targetStatus() { return this.subscriptionChangeStatusFormGroup.get('targetStatus'); }
  get effectiveDate() { return this.subscriptionChangeStatusFormGroup.get('effectiveDate'); }
  get reasons(): FormArray { return this.subscriptionChangeStatusFormGroup.get('reasons') as FormArray; }

  constructor(
    private dialogRef: MatDialogRef<AddSubscriptionHistoryPopupComponent>,
    private fb: UntypedFormBuilder,
    private dateAdapter: DateAdapter<any>,
    private translateService: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: { canUpdateSubscriptionActive: boolean, canUpdateSubscriptionTerminated: boolean }
  ) {
    this.initForm();
  }

  ngOnInit(): void {
    this.dateAdapter.setLocale(this.translateService.getCurrentLang());

    if (this.data.canUpdateSubscriptionActive) {
      this.targetStatusList.push(SubscriptionStatusEnum.ACTIVE, SubscriptionStatusEnum.INACTIVE);
    }
    if (this.data.canUpdateSubscriptionTerminated) {
      this.targetStatusList.push(SubscriptionStatusEnum.TERMINATED);
    }

    if (this.targetStatusList.length > 0) {
       this.targetStatus.setValue(this.targetStatusList[0]);
    }
  }

  onSubmitSubscriptionStatusForm() {
    const effectiveDateValue = moment(this.effectiveDate.value).toDate();
    let reasonsValues = this.reasons.value;
    reasonsValues = reasonsValues.map((r: string) => r.trim()).filter(r => r);

    this.dialogRef.close({
      status: this.targetStatus.value,
      effectiveDate: effectiveDateValue,
      reason: reasonsValues,
      isDeferred: this.isDeferred.value
    });
  }

  cancel() {
    this.dialogRef.close();
  }

  addRaison() {
    if (this.reasons.length >= this.maxReasons) {
      return;
    }
    this.reasons.push(this.fb.control(''));
  }

  removeRaison(index: number) {
    this.reasons.removeAt(index);
  }

  private initForm() {
    this.subscriptionChangeStatusFormGroup = this.fb.group({
      isDeferred: this.fb.control(false),
      targetStatus: this.fb.control(null, [Validators.required]),
      effectiveDate: this.fb.control(null),
      reasons: this.fb.array([ this.fb.control('') ])
    });

    this.subscriptionChangeStatusFormGroup.get('isDeferred')!.valueChanges.subscribe(value => {
      const dateCtrl = this.subscriptionChangeStatusFormGroup.get('effectiveDate')!;
      if (value) {
        dateCtrl.setValidators([Validators.required]);
      } else {
        dateCtrl.clearValidators();
      }
      dateCtrl.updateValueAndValidity();
    });
  }

}
